import { type DriverCategory } from "../utils/driverPageLocation";
import useTableStore from "../stores/useTableStore";
import { match } from "ts-pattern";
import { driverCategoryOptionsEn } from "../utils/driverPageLocation";

function useDriversListPaginationState(
    driverCategory: DriverCategory = "drivers"
) {
    const orderBy = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.allDriversOrderBy
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.professionalDriversOrderBy
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.greyFleetOrderBy
            )
            .otherwise(() => state.allDriversOrderBy)
    );

    const sortOrder = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.allDriversSortOrder
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.professionalDriversSortOrder
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.greyFleetSortOrder
            )
            .otherwise(() => state.allDriversSortOrder)
    );

    const pageNumber = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.allDriversPageNumber
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.professionalDriversPageNumber
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.greyFleetPageNumber
            )
            .otherwise(() => state.allDriversPageNumber)
    );

    const pageSize = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.allDriversPageSize
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.professionalDriversPageSize
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.greyFleetPageSize
            )
            .otherwise(() => state.allDriversPageSize)
    );

    const setOrderBy = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.setAllDriversOrderBy
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.setProfessionalDriversOrderBy
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.setGreyFleetOrderBy
            )
            .otherwise(() => state.setAllDriversOrderBy)
    );

    const setSortOrder = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.setAllDriversSortOrder
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.setProfessionalDriversSortOrder
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.setGreyFleetSortOrder
            )
            .otherwise(() => state.setAllDriversSortOrder)
    );

    const setPageNumber = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.setAllDriversPageNumber
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.setProfessionalDriversPageNumber
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.setGreyFleetPageNumber
            )
            .otherwise(() => state.setAllDriversPageNumber)
    );

    const setPageSize = useTableStore((state) =>
        match(driverCategory)
            .with(
                driverCategoryOptionsEn.drivers,
                () => state.setAllDriversPageSize
            )
            .with(
                driverCategoryOptionsEn.professionalDrivers,
                () => state.setProfessionalDriversPageSize
            )
            .with(
                driverCategoryOptionsEn.greyfleet,
                () => state.setGreyFleetPageSize
            )
            .otherwise(() => state.setAllDriversPageSize)
    );

    const setDefaults = () => {
        setOrderBy("LastName");
        setSortOrder("asc");
        setPageNumber(1);
        setPageSize(25);
    };

    const isDefault =
        orderBy === "LastName" &&
        sortOrder === "asc" &&
        pageNumber === 1 &&
        pageSize === 25;

    return {
        orderBy,
        setOrderBy,
        sortOrder,
        setSortOrder,
        pageNumber,
        setPageNumber,
        pageSize,
        setPageSize,
        setDefaults,
        isDefault,
    };
}

export default useDriversListPaginationState;
